import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import GoogleLoginButton from './GoogleLoginButton';

const Navigation = () => {
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);

  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);

  const navLinks = [
    { path: '/title', text: 'Home', isExternal: false },
    { path: '/blog', text: 'Blog', isExternal: false },
    { path: 'http://codefad.co.uk', text: 'Codefad', isExternal: true },
    { path: '/music', text: 'Music', isExternal: false },
    { path: '/photos', text: 'Photos', isExternal: false },
    { path: '/utils', text: 'Utils', isExternal: false }
  ];

  return (
    <nav className="navbar navbar-inverse navbar-fixed-top">
      <div className="container">
        <div className="navbar-header page-scroll">
          <button
            type="button"
            className="navbar-toggle"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
            onClick={handleNavCollapse}
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <Link className="navbar-brand" to="/title">
            <span>-</span> Phil Withey <span>-</span>
          </Link>
        </div>

        <div className={`collapse navbar-collapse ${!isNavCollapsed ? 'in' : ''}`} id="bs-example-navbar-collapse-1">
          <ul className="nav navbar-nav navbar-right">
            <li className="hidden">
              <a href="#page-top" aria-label="Page top">Page top</a>
            </li>
            {navLinks.map((link, index) => (
              <li key={index} className="page-scroll">
                {link.isExternal ? (
                  <>
                    <a className="hidden-xs" href={link.path} target="_blank" rel="noopener noreferrer">
                      {link.text}
                    </a>
                    <a
                      className="visible-xs"
                      data-toggle="collapse"
                      data-target=".navbar-collapse"
                      href={link.path}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {link.text}
                    </a>
                  </>
                ) : (
                  <>
                    <NavLink
                      className={({ isActive }) => `hidden-xs${isActive ? ' active' : ''}`}
                      to={link.path}
                      end={link.path === '/title'}
                    >
                      {link.text}
                    </NavLink>
                    <NavLink
                      className={({ isActive }) => `visible-xs${isActive ? ' active' : ''}`}
                      data-toggle="collapse"
                      data-target=".navbar-collapse"
                      to={link.path}
                      end={link.path === '/title'}
                    >
                      {link.text}
                    </NavLink>
                  </>
                )}
              </li>
            ))}
            <li>
              <NavLink to="/map" className={({ isActive }) => isActive ? "active" : ""}>
                Map
              </NavLink>
            </li>
            <GoogleLoginButton />
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
